import { Box, FormControl, InputLabel, MenuItem, Select, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { Controller } from "react-hook-form";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import CustomDialog from "../CustomDialog";
import NullCheck from "components/NullCheck";

const SelectColorPicker = ({
  control,
  title,
  name,
  required,
  errors,
  width,
  colors,
  validation,
  defaultValue,
  disabled,
  hideName

}) => {
  const { bt } = useBizTypeTranslation();
  const [openMassge, setOpenMassge] = useState(false);
  const error = errors ? errors[name]?.ref?.name : false;
  const massge = errors ? errors[name]?.message : "";

  return (
    <Stack>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue ?? ""}
        rules={{
          required: required ? bt("REQUIRED") : false,
          pattern: {
            value: validation?.regex,
            message: bt(validation?.massge),
          },
        }}
        render={({ field: { onChange, value } }) => (
          <FormControl
            size="small"
            variant="outlined"
            sx={{ minWidth: width ?? 80 }}
            error={error === name}
            disabled={disabled ?? false}
          >
            <InputLabel id={`${name}-label`}>
              {title ? `${required ? "*" : ""}${bt(title)}` : ""}
            </InputLabel>
            <Select
              error={error === `${name}`}
              autoWidth
              label={`${required ? "*" : ""}${bt(title)}`}
              sx={{
                width: width ? width : 80,
                height: 40,
                paddingX: 1,
                padding: 0,
                bgcolor: value || "bg.main",
                "& .MuiSelect-select": {
                  padding: "0px 0px",
                  marginTop: "0px",
                },
              }}
              size="small"
              renderValue={(selected) => (
                <Stack height="100%" justifyContent="center">
                  <Box sx={{
                    width: 80,
                    height: 40,
                  }}></Box>
                </Stack>
              )}
              MenuProps={{ PaperProps: { style: { maxHeight: 150, width: width ? width : 200 } } }}
              defaultValue={defaultValue ?? ""}
              value={value}
              onChange={onChange}
            >
              {colors?.map((option) => {
                return (
                  <MenuItem
                    key={option.id}
                    sx={{ minWidth: width ? width : 200 }}
                    value={option.id}
                  >
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Box
                        width={hideName ? 170 : 20}
                        height={20}
                        sx={{ backgroundColor: option.id }}
                      />
                      <NullCheck valueForCheck={!hideName}>
                        <Typography>{bt(option.name)}</Typography>
                      </NullCheck>
                    </Stack>
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>

        )}
      />

      <NullCheck valueForCheck={massge}>
        <CustomDialog
          title="ERROR"
          open={openMassge}
          width={300}
          onClose={() => setOpenMassge(false)}
          closeBtn="CLOSE"
        >
          <Stack alignItems="center">
            {massge}
          </Stack>
        </CustomDialog>
      </NullCheck>
    </Stack>
  );
};
export default SelectColorPicker;
